import React from "react";

import Styles from "./IconTitle.module.css";
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';

const IconTitle = (props) => {

  return (
    <div className={Styles["iconTitle"]}>
      <div className="row">
        <div className={`col-xs-12 title ${Styles["title-plus-icon"]}`}>
          <IconButton aria-label="forward" className={Styles["icon-button"]} onClick={props.onClick}>
            <Icon className={Styles["rounded-icon-arrow"]}>chevron_left</Icon>
          </IconButton>
          {props.title}
        </div>
      </div>
    </div>
  );
};

export default IconTitle;
